import styled from 'styled-components';


/*
========================================
HELPERS INVITACIÓN
========================================
*/

const colorInvitacion = (
    tipo
) => {

    switch (
        tipo
    ) {

        case 'exito':

            return '#17856B';

        case 'info':

            return '#514BBE';

        case 'advertencia':

            return '#B97813';

        case 'error':

            return '#C94F58';

        case 'vencida':

            return '#C96F1B';

        default:

            return '#646464';

    }

};


const fondoInvitacion = (
    tipo
) => {

    switch (
        tipo
    ) {

        case 'exito':

            return '#F0FAF6';

        case 'info':

            return '#F7F6FE';

        case 'advertencia':

            return '#FFF9EA';

        case 'error':

            return '#FFF2F3';

        case 'vencida':

            return '#FFF4E8';

        default:

            return '#F6F6F4';

    }

};


const bordeInvitacion = (
    tipo
) => {

    switch (
        tipo
    ) {

        case 'exito':

            return '#A9DDD0';

        case 'info':

            return '#D7D4F4';

        case 'advertencia':

            return '#EFC340';

        case 'error':

            return '#E8A9AD';

        case 'vencida':

            return '#E7973C';

        default:

            return '#D8D8D4';

    }

};


/*
========================================
CONTENEDOR GENERAL
========================================
*/

export const ContenedorDatosPaciente =
    styled.div`

    width: 94%;

    max-width: 1050px;

    box-sizing: border-box;

    margin:
        1.5rem
        auto
        3rem
        auto;
`;


/*
========================================
INFORMACIÓN SUPERIOR
========================================
*/

export const EncabezadoPaciente =
    styled.div`

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 1rem;

    flex-wrap: wrap;

    margin-bottom: 1.2rem;
`;


export const InfoPacienteSuperior =
    styled.div`

    display: flex;

    align-items: center;

    gap: 1.5rem;

    flex-wrap: wrap;
`;


export const DatoSuperior =
    styled.div`

    font-size: 0.82rem;

    color: #646464;


    strong {

        color: #2B2B2B;

        font-weight: 700;
    }
`;


/*
========================================
ESTADO DEL PACIENTE
========================================
*/

export const EstadoPaciente =
    styled.div`

    display: inline-flex;

    align-items: center;

    gap: 0.4rem;

    box-sizing: border-box;

    padding:
        0.45rem
        0.8rem;

    border-radius: 18px;

    font-size: 0.76rem;

    font-weight: 700;

    background-color:
        ${
            props =>
                props.$completo
                    ?
                    '#EDF9F4'
                    :
                    '#FFF4E8'
        };

    color:
        ${
            props =>
                props.$completo
                    ?
                    '#17856B'
                    :
                    '#D97721'
        };
`;


/*
========================================
TARJETA PRINCIPAL
========================================
*/

export const TarjetaDatosPaciente =
    styled.div`

    width: 100%;

    box-sizing: border-box;

    padding:
        2rem
        2.2rem;

    border:
        1.5px solid
        #69BEB8;

    border-radius: 22px;

    background-color:
        #FFFFFF;


    @media (max-width: 700px) {

        padding:
            1.3rem
            1rem;
    }
`;


/*
========================================
SECCIONES
========================================
*/

export const SeccionDatosPaciente =
    styled.section`

    width: 100%;

    box-sizing: border-box;
`;


export const EncabezadoSeccionDatos =
    styled.div`

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 1rem;

    margin-bottom: 0.7rem;
`;


export const TituloSeccionDatos =
    styled.h3`

    margin: 0;

    font-size: 1rem;

    font-weight: 800;

    color: #23AAAF;
`;


export const TextoSeccionDatos =
    styled.p`

    margin:
        0.25rem
        0
        0
        0;

    font-size: 0.78rem;

    line-height: 1.45;

    color: #646464;
`;


/*
========================================
SEPARADOR
========================================
*/

export const SeparadorDatosPaciente =
    styled.div`

    width: 100%;

    height: 1px;

    margin:
        1.8rem
        0;

    background-color:
        #D9D9D9;
`;


/*
========================================
GRID
========================================
*/

export const GridDatosPaciente =
    styled.div`

    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(0, 1fr)
        );

    column-gap: 2rem;


    @media (max-width: 700px) {

        grid-template-columns:
            1fr;
    }
`;


/*
========================================
CAMPO DE INFORMACIÓN
========================================
*/

export const CampoDato =
    styled.div`

    min-height: 48px;

    display: grid;

    grid-template-columns:
        max-content
        minmax(0, 1fr)
        auto;

    align-items: center;

    column-gap: 0.55rem;

    box-sizing: border-box;

    padding:
        0.55rem
        0.25rem;

    border-bottom:
        1px solid
        #D9D9D9;


    &[data-completo="true"] {

        grid-column:
            1 / -1;
    }


    &[data-destacado="true"] {

        border-left:
            3px solid
            #655EE8;

        padding-left:
            0.65rem;

        background-color:
            #FAF9FF;
    }


    &[data-destacado="true"] label {

        color:
            #514BBE;

        font-weight:
            800;
    }


    &[data-faltante="true"] {

        border-left-color:
            #E7973C;

        border-bottom-color:
            #E7973C;

        background-color:
            #FFF4E8;
    }


    &[data-faltante="true"] label {

        color:
            #C96F1B;

        font-weight:
            800;
    }


    &[data-error="true"] {

        margin:
            0.3rem
            0;

        padding:
            0.45rem
            0.9rem;

        border:
            2px solid
            #E7973C;

        border-radius:
            20px;

        background-color:
            #FFF4E8;
    }


    &[data-error="true"] label {

        color:
            #E7973C;

        font-weight:
            800;
    }


    @media (max-width: 700px) {

        grid-template-columns:
            1fr;

        align-items:
            stretch;

        row-gap:
            0.3rem;

        padding:
            0.7rem
            0.2rem;
    }
`;


/*
========================================
LABEL
========================================
*/

export const LabelDato =
    styled.label`

    font-size: 0.82rem;

    font-weight: 600;

    white-space: nowrap;

    color: #2B2B2B;


    @media (max-width: 700px) {

        white-space:
            normal;
    }
`;


/*
========================================
VALOR
========================================
*/

export const ValorDato =
    styled.div`

    min-width: 0;

    overflow-wrap: anywhere;

    font-size: 0.84rem;

    color:
        ${
            props =>
                props.$vacio
                    ?
                    '#9A9A96'
                    :
                    '#2B2B2B'
        };

    font-style:
        ${
            props =>
                props.$vacio
                    ?
                    'italic'
                    :
                    'normal'
        };
`;


/*
========================================
INPUT
========================================
*/

export const InputDato =
    styled.input`

    width: 100%;

    min-width: 0;

    height: 36px;

    box-sizing: border-box;

    padding:
        0
        0.65rem;

    border:
        1px solid
        #B8DEDC;

    border-radius:
        7px;

    outline: none;

    background-color:
        #F3FAFA;

    font-family: inherit;

    font-size: 0.84rem;

    color: #2B2B2B;

    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        box-shadow 0.15s ease;


    &:hover:not(:disabled) {

        border-color:
            #69BEB8;
    }


    &:focus {

        border-color:
            #23AAAF;

        background-color:
            #FFFFFF;

        box-shadow:
            0
            0
            0
            2px
            rgba(
                35,
                170,
                175,
                0.12
            );
    }


    &:disabled {

        background-color:
            #F4F4F2;

        border-color:
            #D8D8D4;

        cursor:
            not-allowed;
    }
`;


/*
========================================
SELECT
========================================
*/

export const SelectDato =
    styled.select`

    width: 100%;

    min-width: 0;

    height: 36px;

    box-sizing: border-box;

    padding:
        0
        0.65rem;

    border:
        1px solid
        #B8DEDC;

    border-radius:
        7px;

    outline: none;

    background-color:
        #F3FAFA;

    font-family: inherit;

    font-size: 0.84rem;

    color: #2B2B2B;

    cursor: pointer;

    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        box-shadow 0.15s ease;


    &:hover:not(:disabled) {

        border-color:
            #69BEB8;
    }


    &:focus {

        border-color:
            #23AAAF;

        background-color:
            #FFFFFF;

        box-shadow:
            0
            0
            0
            2px
            rgba(
                35,
                170,
                175,
                0.12
            );
    }


    &:disabled {

        background-color:
            #F4F4F2;

        border-color:
            #D8D8D4;

        cursor:
            not-allowed;
    }
`;


/*
========================================
BOTONES EDICIÓN
========================================
*/

export const AccionesCampo =
    styled.div`

    display: flex;

    align-items: center;

    justify-content: flex-end;

    gap: 0.35rem;
`;


export const BotonEditarCampo =
    styled.button`

    width: 28px;

    height: 28px;

    min-width: 28px;

    display: flex;

    align-items: center;

    justify-content: center;

    box-sizing: border-box;

    padding: 0;

    border:
        1px solid
        transparent;

    border-radius:
        50%;

    background-color:
        transparent;

    color:
        #646464;

    font-family: inherit;

    font-size:
        0.82rem;

    cursor: pointer;

    transition:
        background-color 0.15s ease,
        border-color 0.15s ease,
        color 0.15s ease;


    &:hover {

        border-color:
            #B8DEDC;

        background-color:
            #F3FAFA;

        color:
            #23AAAF;
    }


    &:focus-visible {

        outline:
            2px solid
            #23AAAF;

        outline-offset:
            2px;
    }


    &:disabled {

        opacity:
            0.45;

        cursor:
            not-allowed;
    }
`;


export const BotonConfirmarCampo =
    styled.button`

    width: 30px;

    height: 30px;

    min-width: 30px;

    display: flex;

    align-items: center;

    justify-content: center;

    box-sizing: border-box;

    padding: 0;

    border: none;

    border-radius:
        50%;

    background-color:
        #23AAAF;

    color:
        #FFFFFF;

    font-family: inherit;

    font-size:
        0.88rem;

    font-weight:
        800;

    cursor: pointer;


    &:hover:not(:disabled) {

        opacity:
            0.9;
    }


    &:disabled {

        opacity:
            0.5;

        cursor:
            not-allowed;
    }
`;


export const BotonCancelarCampo =
    styled.button`

    width: 30px;

    height: 30px;

    min-width: 30px;

    display: flex;

    align-items: center;

    justify-content: center;

    box-sizing: border-box;

    padding: 0;

    border:
        1px solid
        #D76970;

    border-radius:
        50%;

    background-color:
        #FFFFFF;

    color:
        #D76970;

    font-family: inherit;

    font-size:
        0.88rem;

    font-weight:
        800;

    cursor: pointer;


    &:hover:not(:disabled) {

        background-color:
            #FFF5F5;
    }


    &:disabled {

        opacity:
            0.5;

        cursor:
            not-allowed;
    }
`;


/*
========================================
ERROR EDICIÓN
========================================
*/

export const TextoErrorDato =
    styled.div`

    grid-column:
        1 / -1;

    margin-top:
        0.2rem;

    font-size:
        0.72rem;

    font-weight:
        700;

    color:
        #E7973C;
`;


/*
========================================
TUTORES
========================================
*/

export const CabeceraTutoresDatos =
    styled.div`

    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(0, 1fr)
        );

    gap:
        2rem;

    margin-top:
        0.9rem;

    padding-bottom:
        0.55rem;

    border-bottom:
        1.5px solid
        #2B2B2B;


    span {

        text-align:
            center;

        font-size:
            0.82rem;

        font-weight:
            800;

        color:
            #2B2B2B;
    }


    @media (max-width: 700px) {

        display:
            none;
    }
`;


/*
========================================
DOMICILIO
========================================
*/

export const BloqueUbicacionDato =
    styled.div`

    width: 100%;

    box-sizing: border-box;

    margin-top:
        0.9rem;
`;


export const EncabezadoUbicacionDato =
    styled.div`

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap:
        1rem;

    margin-bottom:
        0.5rem;
`;


export const TituloUbicacionDato =
    styled.h4`

    margin: 0;

    font-size:
        0.84rem;

    font-weight:
        700;

    color:
        #2B2B2B;
`;


export const ResumenUbicacion =
    styled.div`

    display: flex;

    flex-wrap: wrap;

    gap:
        0.4rem;

    box-sizing: border-box;

    padding:
        0.7rem
        0;

    border-bottom:
        1px solid
        #D9D9D9;
`;


export const ItemUbicacion =
    styled.span`

    display: inline-flex;

    align-items: center;

    box-sizing: border-box;

    padding:
        0.3rem
        0.65rem;

    border:
        1px solid
        #B8DEDC;

    border-radius:
        14px;

    background-color:
        #F3FAFA;

    font-size:
        0.76rem;

    font-weight:
        500;

    color:
        #2B2B2B;


    &:first-child {

        border-color:
            #23AAAF;

        background-color:
            #EAF8F8;

        color:
            #0E7A7E;

        font-weight:
            700;
    }
`;


export const UbicacionVacia =
    styled.div`

    padding:
        0.7rem
        0;

    border-bottom:
        1px solid
        #D9D9D9;

    font-size:
        0.8rem;

    font-style:
        italic;

    color:
        #9A9A96;
`;


/*
========================================
AVISO YÖGEN
========================================
*/

export const AvisoDatosYogen =
    styled.div`

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 1rem;

    flex-wrap: wrap;

    box-sizing: border-box;

    margin-bottom:
        1.2rem;

    padding:
        1rem
        1.2rem;

    border:
        2px solid
        ${
            props => {

                if (
                    props.$vinculacion
                ) {

                    return '#D7D4F4';

                }


                if (
                    props.$errorEmail
                ) {

                    return '#E8A9AD';

                }


                if (
                    props.$invitacionVencida
                ) {

                    return '#E7973C';

                }


                if (
                    props.$incompleto
                ) {

                    return '#E7973C';

                }


                return '#69BEB8';

            }
        };

    border-radius:
        14px;

    background-color:
        ${
            props => {

                if (
                    props.$vinculacion
                ) {

                    return '#F7F6FE';

                }


                if (
                    props.$errorEmail
                ) {

                    return '#FFF7F7';

                }


                if (
                    props.$invitacionVencida ||
                    props.$incompleto
                ) {

                    return '#FFF4E8';

                }


                return '#EDF9F4';

            }
        };

    color:
        ${
            props => {

                if (
                    props.$vinculacion
                ) {

                    return '#514BBE';

                }


                if (
                    props.$errorEmail
                ) {

                    return '#B9434C';

                }


                if (
                    props.$invitacionVencida ||
                    props.$incompleto
                ) {

                    return '#C96F1B';

                }


                return '#17856B';

            }
        };
`;


export const TextoAvisoYogen =
    styled.div`

    flex: 1;

    min-width: 230px;

    font-size:
        0.82rem;

    line-height: 1.5;

    color:
        inherit;


    strong {

        font-weight:
            800;
    }
`;


/*
========================================
ESTADO INVITACIÓN
========================================
*/

export const EstadoInvitacionBox =
    styled.div`

    width:
        100%;

    box-sizing:
        border-box;

    margin-top:
        0.1rem;

    padding:
        0.85rem
        1rem;

    border:
        1px solid
        ${
            props =>
                bordeInvitacion(
                    props.$tipo
                )
        };

    border-radius:
        10px;

    background-color:
        ${
            props =>
                fondoInvitacion(
                    props.$tipo
                )
        };

    color:
        #2B2B2B;
`;


export const CabeceraEstadoInvitacion =
    styled.div`

    display:
        flex;

    align-items:
        center;

    justify-content:
        space-between;

    gap:
        0.7rem;

    flex-wrap:
        wrap;
`;


export const TituloEstadoInvitacion =
    styled.div`

    font-size:
        0.78rem;

    font-weight:
        800;

    color:
        #2B2B2B;
`;


export const BadgeEstadoInvitacion =
    styled.div`

    display:
        inline-flex;

    align-items:
        center;

    box-sizing:
        border-box;

    padding:
        0.3rem
        0.65rem;

    border:
        1px solid
        ${
            props =>
                bordeInvitacion(
                    props.$tipo
                )
        };

    border-radius:
        15px;

    background-color:
        #FFFFFF;

    color:
        ${
            props =>
                colorInvitacion(
                    props.$tipo
                )
        };

    font-size:
        0.68rem;

    font-weight:
        800;
`;


export const EmailEstadoInvitacion =
    styled.div`

    margin-top:
        0.55rem;

    font-size:
        0.78rem;

    font-weight:
        700;

    color:
        #2B2B2B;

    overflow-wrap:
        anywhere;
`;


export const DetalleEstadoInvitacion =
    styled.div`

    margin-top:
        0.35rem;

    font-size:
        0.75rem;

    line-height:
        1.45;

    color:
        #646464;


    strong {

        color:
            #2B2B2B;

        font-weight:
            800;
    }
`;


export const MetaEstadoInvitacion =
    styled.div`

    margin-top:
        0.45rem;

    font-size:
        0.7rem;

    font-weight:
        700;

    color:
        #646464;
`;


/*
========================================
AYUDA
========================================
*/

export const BotonAyudaDatos =
    styled.button`

    width:
        24px;

    height:
        24px;

    min-width:
        24px;

    display: flex;

    align-items: center;

    justify-content: center;

    padding:
        0;

    border:
        1.5px solid
        #655EE8;

    border-radius:
        50%;

    background-color:
        #FFFFFF;

    color:
        #655EE8;

    font-family:
        inherit;

    font-size:
        0.78rem;

    font-weight:
        800;

    cursor:
        pointer;


    &:hover {

        background-color:
            #F3F1FF;
    }
`;


/*
========================================
ACCIONES AVISO
========================================
*/

export const AccionesAvisoDatosYogen =
    styled.div`

    display:
        flex;

    align-items:
        center;

    gap:
        0.55rem;
`;


export const BotonInvitarPaciente =
    styled.button`

    min-height:
        34px;

    box-sizing:
        border-box;

    padding:
        0.45rem
        0.9rem;

    border:
        none;

    border-radius:
        9px;

    background-color:
        #FC8906;

    color:
        #FFFFFF;

    font-family:
        inherit;

    font-size:
        0.76rem;

    font-weight:
        800;

    white-space:
        nowrap;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        opacity:
            0.9;
    }


    &:disabled {

        background-color:
            #D8D8D4;

        color:
            #777777;

        cursor:
            not-allowed;

        opacity:
            1;
    }
`;


/*
========================================
SOLICITAR VINCULACIÓN
========================================
*/

export const BotonSolicitarVinculacion =
    styled.button`

    min-height:
        34px;

    box-sizing:
        border-box;

    padding:
        0.45rem
        0.9rem;

    border:
        none;

    border-radius:
        9px;

    background-color:
        #655EE8;

    color:
        #FFFFFF;

    font-family:
        inherit;

    font-size:
        0.76rem;

    font-weight:
        800;

    white-space:
        nowrap;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        opacity:
            0.9;
    }


    &:disabled {

        opacity:
            0.55;

        cursor:
            not-allowed;
    }
`;